export default __webpack_public_path__ + "static/illustration-5765231d0fc1abffddea0ef11cd12b5d.png";